import { useNavigate, useLocation } from "react-router-dom";

function useQueryParam(DefaultSettings) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // SETTER that sets either primitive or array value
  const setQueryParam = (key, val) => {
    // Clear existing key first
    params.delete(key);

    if (val !== DefaultSettings[key]) {
      if (Array.isArray(val)) {
        if (val.length > 0) {
          val.forEach((v) => params.append(key, v)); // repeated keys style
        }
      } else if (val !== undefined && val !== null) {
        params.set(key, val);
      }
    }

    navigate(
      `${location.pathname}?${params.toString()}`,
      { replace: true } // prevents adding an extra entry to history.
    );
  };

  // GETTER that returns array if multiple values exist or single value otherwise
  const getQueryParam = (key, array) => {
    const allVals = params.getAll(key);
    if (array) return allVals;
    else return allVals[0] || DefaultSettings[key];
  };

  return {
    params,
    setQueryParam,
    getQueryParam,
  };
}

export default useQueryParam;